import loadingTools from '../loadingTools';
import qtiConstants from '../../../qti/Constants';
import MathJax2Display from '../../../components/question/mathDisplay/MathJax2Display';

const { MATHJAX2 } = qtiConstants.staticLibPaths;
const VERSION = '2.7.2';
const MathJaxLoader = {
    getAllFilesToCache() {
        return [
            { url: `${MATHJAX2}MathJax.js?config=TeX-AMS_SVG`, type: 'js' },
            { url: `${MATHJAX2}MathJax.js?config=TeX-AMS_HTML`, type: 'js' },
            { url: `${MATHJAX2}config/TeX-AMS_SVG.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}config/TeX-AMS_HTML.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}extensions/MathMenu.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}extensions/MathZoom.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}jax/output/SVG/jax.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}jax/output/SVG/fonts/TeX/fontdata.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}jax/output/SVG/fonts/TeX/AMS/Regular/Main.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}jax/output/SVG/fonts/TeX/Size1/Regular/Main.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}jax/output/SVG/fonts/TeX/Size2/Regular/Main.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}jax/output/SVG/fonts/TeX/Size3/Regular/Main.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}jax/output/SVG/fonts/TeX/Size4/Regular/Main.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}jax/output/SVG/fonts/TeX/Main/Bold/Main.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}jax/output/SVG/fonts/TeX/Main/Regular/BasicLatin.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}jax/output/SVG/fonts/TeX/Main/Regular/GreekAndCoptic.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}jax/output/HTML-CSS/jax.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}jax/element/mml/optable/GreekAndCoptic.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}localization/cdo/cdo.js?V=${VERSION}`, type: 'js' },
            { url: `${MATHJAX2}localization/cdo/MathMenu.js?V=${VERSION}`, type: 'js' },
        ];
    },

    async init() {
        const MathJax = await loadingTools.loadLibrary(`${MATHJAX2}MathJax.js?config=TeX-AMS_SVG&noContrib`, 'MathJax');
        MathJax2Display.configureMathJaxIfNeeded(MathJax);
        await new Promise((resolve) => {
            MathJax.Hub.Register.StartupHook('End', () => {
                resolve(MathJax);
            });
        }).timeout(20000);
        await loadingTools.loadLibrary(`${MATHJAX2}jax/output/SVG/jax.js?V=${VERSION}`);
        await loadingTools.loadLibrary(`${MATHJAX2}jax/output/SVG/fonts/TeX/fontdata.js?V=${VERSION}`);
        await Promise.all([
            loadingTools.loadLibrary(`${MATHJAX2}jax/output/SVG/fonts/TeX/Size1/Regular/Main.js?V=${VERSION}`),
            loadingTools.loadLibrary(`${MATHJAX2}jax/output/SVG/fonts/TeX/Size2/Regular/Main.js?V=${VERSION}`),
            loadingTools.loadLibrary(`${MATHJAX2}jax/output/SVG/fonts/TeX/Size3/Regular/Main.js?V=${VERSION}`),
            loadingTools.loadLibrary(`${MATHJAX2}jax/output/SVG/fonts/TeX/Size4/Regular/Main.js?V=${VERSION}`),
        ]);
    },
};

export default MathJaxLoader;
